export enum EnumTpStatusPedido {
    Invalido = 0,
    AguardandoConfirmação = 1,
    Confirmado = 2,
    EmPreparo = 3,
    Enviado = 4,
    FinalizadoOuEntregue = 5,
    Cancelado = 6,
    Todos = -1,
}